import React, { useState, useEffect, useRef } from "react";
import Config from "../../utils/config";
import Request from "../../utils/Request";
import CsvDown from "../../components/ExportFiles/CsvDown";
import Pagination from "../../components/common/Pagination";
import { useNavigate } from "react-router-dom";
import { TableWarpper, TabsDetailsWrapper, Text, ButtonSolid } from "../../components/styledConstants";
import { Heading } from "../../components/styledConstants";
import { Wrapper } from "./style";
import IconDate from "../../assets/images/IconDate";
import { getParams } from "../../utils/common";
import FilterBox from "../../components/common/FilterBox";
import { CSVLink, CSVDownload } from "react-csv";
import IconDownload from "../../assets/images/IconDownload";
import { dateConvertWithoutTime } from "../../utils/common";
import { FilterWrapper } from "../Merchants/style";

const paymentModeOptions = [
  { value: "P2P", label: "P2P" },
  { value: "BT", label: "BANK TRANSFER" },
  { value: "VA", label: "VIRTUAL ACCOUNT" },
  { value: "UPI_PAYMENT", label: "UPI PAYMENT" },
  { value: "UPI_COLLECT", label: "UPI COLLECT" },
  { value: "PREPAID_CARD", label: "PREPAID CARD" },
  { value: "BBPS", label: "BBPS" },
  { value: "MRE", label: "RECHARGE" },
  { value: "WALLET", label: "WALLET" },
  { value: "PAYMENT_GATEWAY", label: "PAYMENT GATEWAY" },
];

const filterForm = [
  {
    icon: <IconDate />,
    name: "fromDate",
    value: "",
    className: "item-text pl16",
    dateFormat: "d-MM-yyyy",
    type: "date",
    showMonthDropdown: true,
    showYearDropdown: true,
    yearDropdownItemNumber: 80,
    scrollableYearDropdown: true,
    placeholder: "Date",
    maxDate: new Date(),
    error: "",
  },
 
//   {
//     name: "transactionType",
//     type: "select",
//     placeholder: "Mode",
//     options: paymentModeOptions,
//     error: "",
//   },
];

export default function MainReports() {
  const [controls, setControls] = useState([...filterForm]);
  const [filterFormData, setFilterFormData] = useState({ fromDate: "", toDate: "" });
  const [headers, setHeaders] = useState([]);
  const [reportName, setReportName] = useState("report.csv");
  const [reportList, setReportList] = useState({});
  const [totalPages, setTotalPages] = useState(1);
  const [currentPage, setCurrentPage] = useState(1);
  const [downloadPayload, setDownloadPayload] = useState({});
  const [loading, setLoading] = useState(false);
  const [columnKeys, setColumnKeys] = useState([]);
  const [downloadData, setDownloadData] = useState([]);
  const [totalElements, setTotalElements] = useState(10);

  let navigate = useNavigate();
 

  

  const onFilterChange = (event, index) => {
    const _controls = [...controls];
    _controls[index].value =
      event instanceof Date || (event && event.label) ? event : event ? event.target.value : event;

    setControls([..._controls]);
  };

  const onFilterSubmit = (e) => {
    e.preventDefault();
    const params = getParams(controls);
    const _controls = [...controls];
    let flag = 0;
    if (params.fromDate) {
      setFilterFormData({ ...filterFormData, fromDate: params.fromDate, toDate: params.toDate });
      _controls[0].error = "";
    } else {
      _controls[0].error = "Date Required";
      flag = 1;
    }

    


    
    setControls([..._controls]);
   // clearMessage();
    if (flag === 0) {
      getReportList(1);
    }

    setCurrentPage(1);
 };

  const getReportList = (page = 1) => {
    const successHandler = (res) => {

      console.log("response dowload",res);
      setReportList(res?.data)
    };
    const errorHandler = () => {};
    const api = new Request("", successHandler, errorHandler, false);
    setLoading(true);
    const params = getParams(controls);
    let payload = {
   
      currentDate: dateConvertWithoutTime(params?.fromDate),
      pagination: {
        pageNo: currentPage,
        pageSize: 10,
      },
    };
    setDownloadPayload(payload);
    setReportName(params?.transactionType?.value + ".csv");
    return api.post(`${Config.apis.admin.DOWNLOAD_REPORT}`, payload);
  };

  // const downloadReportList = () => {

  //   const successHandler = (res) => {
  //     if (res) {
  //       if (res.data?.content) {
  //         let listKeys = [];
  //         if (res?.data?.content[0]?.response) {
  //           listKeys = Object.keys(res?.data?.content[0]?.response);
  //         }

  //         let _downloadData = [];
  //         _downloadData.push(listKeys);
  //         res?.data?.content.map((item) => {
  //           let _downloadItemData = [];
  //           listKeys.map((keyname) => {
  //             _downloadItemData.push(item.response[keyname]);
  //           });
  //           _downloadData.push(_downloadItemData);
  //         });
  //         setDownloadData(_downloadData);
  //         setTimeout(() => {
  //           csvLinkRef.current.link.click();
  //         }, 0);
  //       }
  //     }
  //   };
  //   const errorHandler = () => {
 
  //   };

  //   const params = getParams(controls);
  //   const pagination = {
  //     pageNo: 1,
  //     pageSize: totalElements,
  //   }
  //   let payload = {...downloadPayload,pagination:pagination };
  //   const api = new Request("", successHandler, errorHandler, false);
 
  //   return api.post(`${Config.apis.admin.REPORT_BY_TRANSACTION}`, payload);
  // };

  // const clearMessage = () => {
  //   setTimeout(() => {
  //     const _controls = [...controls];
  //     _controls[0]?.error = "";
     
  //     setControls([..._controls]);
  //   }, 3000);
  // };
  const setActivePage = (page) => {
    setCurrentPage(page);
    getReportList(page);
  };
  // useEffect(()=>{
  //   getReportList();
  // },[])
  const resetFilter = () => {
    filterForm.forEach((obj) => {
      obj.value = "";
    });
  };
  const refreshPage = () => {
    resetFilter();
    setCurrentPage(1);
    getReportList();
  };

  useEffect(()=>{
    return(()=>{
      resetFilter();
    })
  },[])
  const downloadfile = (filename) => {
    const successHandler = (res) => {
      // Assuming the response contains the file data as Blob (binary)
      const blob = new Blob([res], { type: "text/csv" }); // Assuming it's a CSV file
      
      // Create a link element
      const link = document.createElement('a');
      
      // Create a URL for the blob
      const url = window.URL.createObjectURL(blob);
      link.href = url;
      
      // Set the download attribute with the filename (or a default name)
      link.setAttribute('download', 'report.csv' || 'report.csv');
      
      // Append the link to the document body
      document.body.appendChild(link);
      
      // Programmatically trigger the click to start the download
      link.click();
      
      // Remove the link from the document after the download
      document.body.removeChild(link);
  
      // Clean up the URL object created for the blob
      window.URL.revokeObjectURL(url);
    };
  
    const errorHandler = (error) => {
      console.error("Error downloading the file:", error);
    };
  
    const api = new Request("", successHandler, errorHandler, false);
  
    // Make the API request to download the file. This returns a Blob or binary data.
    api.get(`${Config.apis.admin.DOWNLOAD_REPORT}/${filename}`, { responseType: 'blob' });
  };
  


  return (
    <Wrapper>
      <div className="flex flex-center space-between mb10">
        <>
          <Heading size="xxl">Main-Reports</Heading>
        </>
      </div>
      <div className="mt32">
        <TabsDetailsWrapper>
        <FilterWrapper>  <FilterBox 
          filterForm={filterForm} 
          onFilterChange={onFilterChange} 
          onFilterSubmit={onFilterSubmit}
          refreshPage={refreshPage}
          /></FilterWrapper>
        
          <TableWarpper className="mt24">
            <table className="table">
              <thead>
                <tr>
                <th>
                  <Text size="rg" fw="medium">S NO.</Text>
                 </th>
                 <th>
                  <Text size="rg" fw="medium">Number of Records</Text>
                 </th>
                
                 <th>
                  <Text size="rg" fw="medium">Reports Date</Text>
                 </th>
                 <th>
                  <Text size="rg" fw="medium">Status</Text>
                 </th>
                 <th>
                  <Text size="rg" fw="medium">Download File</Text>
                 </th>
                </tr>
              </thead>
              <tbody>
             {reportList && reportList?.length ?( reportList.map((item,index)=>(  
              <tr key={index}>
                 <td>
                        <Text size="xsm" color="color3">
                          {index+1}
                        </Text>
                      </td>
                      <td>
                        <Text size="xsm" color="color3">
                          {item?.recordCount}
                        </Text>
                      </td>
                      
                      <td>
                        <Text size="xsm" color="color3">
                          {item?.reportGenDate}
                        </Text>
                      </td>
                      <td>
                        <Text size="xsm" color={item.status==='ACTIVE'?"color10":item.status==='INACTIVE'?"color11":"color4"}>
                          {item?.status}
                        </Text>
                      </td>
                      {item.status==='ACTIVE'?<td className="flex">
                      
                        <p className="" style={{cursor:"pointer", background:"green", padding:"5px", width:"40px",textAlign:"center",borderRadius:"4PX"}}
                          onClick={()=>downloadfile(item?.fileId)}
                        >
                        <IconDownload color="#fff">
                       
                        </IconDownload>
                        </p>
                       
                      </td>:""}
                      
                      </tr>

                 ))):(
              <tr>
                <td colSpan={9} style={{ textAlign: "center" }}>No record found </td>
              </tr>
            )}
                
              </tbody>
            </table>
          </TableWarpper>

          <div className="mt24 flex flex-center">
            {totalPages > 1 && (
              <Pagination
                totalPages={totalPages}
                currentPage={currentPage}
                getCurrentPageData={(curpage) => {
                  setActivePage(curpage);
                }}
              />
            )}
          </div>
        </TabsDetailsWrapper>
      </div>
    </Wrapper>
  );
}
